import { t } from "@/i18n-js/instance";
import { IconButton } from "@circle-react-shared/uikit/HeaderV3/IconButton";
import { useBuilderStore } from "../Hooks/useBuilderStore";
import { SidebarHeader } from "../Sidebar/SidebarHeader";
import { SidebarHeaderTitle } from "../Sidebar/SidebarHeaderTitle";
import { FormWrapper } from "../ThemeConfiguration/FormWrapper";
import { themeComponentMap } from "./ThemeComponentMap";

export const SiteThemes = () => {
  const { actionSidebarView, closeSidebarView, toggleSidebarView } =
    useBuilderStore(state => ({
      actionSidebarView: state.actionSidebarView,
      closeSidebarView: state.closeSidebarView,
      toggleSidebarView: state.toggleSidebarView,
    }));

  const handleBack = () => {
    if (actionSidebarView === "siteThemeList") {
      toggleSidebarView("design");
    } else {
      toggleSidebarView("siteThemeList");
    }
  };

  const { title, content } = themeComponentMap[actionSidebarView];

  return (
    <div className="divide-primary flex h-full w-[23rem] flex-col divide-y">
      <SidebarHeader>
        <div className="flex w-full items-center justify-between">
          <div className="flex items-center gap-2">
            <IconButton
              name="24-arrow-left"
              iconSize={24}
              ariaLabel={t("back")}
              onClick={handleBack}
            />
            <SidebarHeaderTitle>{title}</SidebarHeaderTitle>
          </div>
          <IconButton
            name="24-close"
            iconSize={24}
            ariaLabel={t("close")}
            onClick={closeSidebarView}
          />
        </div>
      </SidebarHeader>
      <FormWrapper>{content}</FormWrapper>
    </div>
  );
};
